import React from 'react';
import { Link } from 'react-router-dom';
import ContactForm from '../components/ContactForm';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-page">
      {/* ── Hero ── */}
      <section className="contact-hero">
        <div className="contact-hero__inner">
          <div className="contact-hero__breadcrumb">
            <Link to="/">Home</Link>
            <span className="contact-hero__breadcrumb-sep">/</span>
            <span className="contact-hero__breadcrumb-current">Contact</span>
          </div>
          <h1 className="contact-hero__title">Get in Touch</h1>
          <p className="contact-hero__subtitle">
            We are here to help with your Lasting Power of Attorney requirements
          </p>
        </div>
      </section>

      {/* ── Main Content ── */}
      <section className="contact-main">
        <div className="contact-main__inner">
          {/* Left Column */}
          <div className="contact-info">
            <h2 className="contact-info__title">Contact Us</h2>
            <p className="contact-info__text">
              Whether you are putting a Lasting Power of Attorney in place for the first
              time, reviewing existing arrangements or have questions about the process,
              we are happy to help. Contact us by email, telephone or using the form and
              we will respond promptly.
            </p>

            <div className="contact-details">
              <div className="contact-details__item">
                <div className="contact-details__icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M22 6l-10 7L2 6" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="contact-details__content">
                  <span className="contact-details__label">Email</span>
                  <a href="mailto:info@theLPAcompany.com" className="contact-details__value">
                    The LPA Company
                  </a>
                </div>
              </div>

              <div className="contact-details__item">
                <div className="contact-details__icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="var(--accent)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <div className="contact-details__content">
                  <span className="contact-details__label">Telephone</span>
                  <a href="tel:03301334433" className="contact-details__value">
                    0330 133 4433
                  </a>
                </div>
              </div>

              <div className="contact-details__item">
                <div className="contact-details__icon">
                  <svg width="20" height="20" viewBox="0 0 448 512" fill="var(--accent)"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"/></svg>
                </div>
                <div className="contact-details__content">
                  <span className="contact-details__label">WhatsApp</span>
                  <a href="https://wa.me/message/O2E665HYYHONE1" target="_blank" rel="noopener noreferrer" className="contact-details__value">
                    Message us on WhatsApp
                  </a>
                </div>
              </div>

            </div>

            <div className="contact-note">
              <p>
                Contacting us does not create a solicitor-client relationship until
                instructions have been formally accepted in writing.
              </p>
            </div>
          </div>

          {/* Right Column */}
          <div className="contact-form-wrapper">
            <ContactForm inline={true} />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
